<script setup>
import { useVueFlow } from '@vue-flow/core';

const { screenToFlowCoordinate } = useVueFlow();

defineExpose({
  screenToFlowCoordinate,
});
</script>

<template>
  <div class="hidden" />
</template>
